module.exports = __webpack_public_path__ + "png/quick-registration-photo-1.png?4da4cab303727ecb0a11170693e5a2e8";